import PropTypes from 'prop-types';
import React from 'react';
import CardholderPersonalizationOptions from './CardholderPersonalizationOptions';
import { isAbleActProgramAccount } from 'react/shared/utils/account_program_type';

export default function BulkCardOrderConfirmationBox({
  activationContext,
  bulkCardOrder,
  cardholderName,
  onClose,
}) {
  const fundingAndSpendingMonitorDetails = () => {
    if (!isAbleActProgramAccount(activationContext.programName)) {
      return ` Please proceed to ${cardholderName}'s dashboard to fund the card and configure Spending Settings.`;
    }
    return null;
  };

  return (
    <div>
      Success! This card is now activated and listed on your dashboard under {cardholderName}.
      {fundingAndSpendingMonitorDetails()}
      {bulkCardOrder && (
        <CardholderPersonalizationOptions
          activationContext={activationContext}
          cardholderName={cardholderName}
          onClose={onClose}
        />
      )}
    </div>
  );
}

BulkCardOrderConfirmationBox.propTypes = {
  activationContext: PropTypes.object.isRequired,
  bulkCardOrder: PropTypes.bool,
  cardholderName: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};
